export const QUERY_KEYS = {
  GET_TOP_SEARCH_DATA: "GET_TOP_SEARCH_DATA",
  GET_TOP_SEARCH_DATA_V2: "GET_TOP_SEARCH_DATA_V2",
};
  